import { render, staticRenderFns } from "./ChatDetailDialog.vue?vue&type=template&id=52d22cd8"
import script from "./ChatDetailDialog.vue?vue&type=script&lang=js"
export * from "./ChatDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports